export default "dist/1ff49fd4eddddb2bde9f78c2434bb12e.png";